import React from 'react';
import PhoneInputField from 'modules/Common/form/PhoneInputField';

export default function PhoneField({ field, fieldState, id, placeholder, disabled }) {
  return (
    <div id={id}>
      <PhoneInputField
        value={field.value || ''}
        onChange={(v) => field.onChange(v)}
        disabled={disabled}
        hasError={!!fieldState?.error}
        placeholder={placeholder}
      />
    </div>
  );
}
